import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../actions";
import api from "../api/api";
import UserApi from "../api/UserApi";
import {
  followUserOptimistic,
  unfollowUserOptimistic,
  followUserFailed,
  unfollowUserFailed,
} from "../actions/userActions";
import windowDataLayer from "../util/windowDataLayer";

function* handleUnfollowRequests(action) {
  const request = UserApi.getUnfollowUserReq(action.userId);
  yield put(unfollowUserOptimistic({ userId: action.userId, postId: action.postId }));
  try {
    yield call(api.delete, request.url);
  } catch (error) {
    yield put(unfollowUserFailed({ userId: action.userId, postId: action.postId }));
    yield put(showAlert("Sorry, Couldn't unfollow", "error"));
  }
}

function* handleFollowRequests(action) {
  const request = UserApi.getFollowUserReq(action.userId);
  yield put(followUserOptimistic({ userId: action.userId, postId: action.postId }));
  try {
    yield call(api.post, request.url, request.config);
    windowDataLayer.push({ event: "follow" });
  } catch (error) {
    yield put(followUserFailed({ userId: action.userId, postId: action.postId }));
    yield put(showAlert("Sorry, Couldn't follow", "error"));
  }
}

export function* watchFollowRequests() {
  yield takeLatest("UNFOLLOW_USER_REQUEST", handleUnfollowRequests);
  yield takeLatest("FOLLOW_USER_REQUEST", handleFollowRequests);
}

export default watchFollowRequests;



// WEBPACK FOOTER //
// ./src/sagas/FollowSaga.js